import { useSelector } from "react-redux";
// Import directly from selectors to avoid circular dependency
// (barrel import triggers thunks which import @b2bportal/core-packages)
import { getPricingMode } from "@/store/flights/shop/store/selectors";

export const useShouldPopulateFarePriceBreakdown = () => {
  const pricingMode = useSelector(getPricingMode);
  return pricingMode === "fixed";
};
